<div class="valg-message-bar" [class.valg-message-bar__small]="isSmall" [class.valg-message-bar__rounded-top]="roundedTop" [ngClass]="elementClass+'__'+color" [attr.role]="isError() ? 'alert' : null" [attr.aria-atomic]="isError() ? 'true' : null" >
  <div class="valg-message-bar__warning-icon" *ngIf="isError() || messageBarState === MessageBarStateEnum.Error">
    <mat-icon [svgIcon]="SvgIcon.ErrorWarning"></mat-icon>
  </div>
  <div class="valg-message-bar__warning-icon" *ngIf="messageBarState === MessageBarStateEnum.Success">
    <mat-icon [svgIcon]="SvgIcon.CheckmarkFilled"></mat-icon>
  </div>
  <div class="valg-message-bar__content">
    <ng-content></ng-content>
  </div>
  <valg-tip *ngIf="shouldShowGuidance()" [data]="tip"></valg-tip>
</div>
